<template lang="html">
  <div
    v-tracking-context="{ page_type: currentPageType }"
    class="fsd-session"
    :class="formatClasses"
  >
    <tabs
      :head="{
        login: $options.filters.t('client.session.tabs.login'),
        registration: $options.filters.t('client.session.tabs.registration')
      }"
      :initial-tab="initialTab"
      :classes="formatClasses"
      @tabChanged="onTabChanged"
    >
      <template #login>
        <div class="card fsd-login__container">
          <slot />
          <Login
            :return-to="returnTo"
            :reason="reason"
            :should-redirect-after-login="shouldRedirectAfterLogin"
            :registration-campaign-id="registrationCampaignId"
            :current-search-profile="currentSearchProfile"
          />
        </div>
      </template>
      <template #registration>
        <div class="card fsd-registration__container">
          <slot />
          <Registration
            :return-to="returnTo"
            :registration-campaign-id="registrationCampaignId"
            :search-profile="currentSearchProfile"
          />
        </div>
      </template>
      <template #footer>
        <div class="card fsd-session__footer">
          <a
            v-if="showTroubleshootingLink"
            v-click-track="{
              event_element: 'troubleshooting',
              action_type: 'visit'
            }"
            class="ac-link ac-link--primary"
            @click="loginCurrentPageSet('troubleshooting')"
          >
            {{ 'client.login.troubleshooting.headline' | t }}
          </a>
          <a
            v-if="showBackToLoginLink"
            v-click-track="{
              event_element: 'login',
              action_type: 'visit'
            }"
            class="ac-link ac-link--primary"
            @click="loginCurrentPageSet('emailLogin')"
          >
            {{ 'client.login.troubleshooting.back_to_login' | t }}
          </a>
        </div>
      </template>
    </tabs>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Tabs from '@/vue/components/fused/modal/tabs.vue'
import Login from '@/vue/components/fused/sessions/login.vue'
import Registration from '@/vue/components/fused/sessions/registration.vue'

export default {
  name: 'Session',
  components: { Login, Registration, Tabs },
  props: {
    webtrekkPageType: {
      type: String,
      default: null
    },
    returnTo: {
      type: String,
      default: null
    },
    initialTab: {
      type: String,
      default: 'login'
    },
    modalWide: {
      type: Boolean,
      default: false
    },
    reason: {
      type: String,
      default: null
    },
    registrationCampaignId: {
      type: String,
      default: null
    },
    registrationSearchProfile: {
      type: Object,
      default: null
    },
    shouldRedirectAfterLogin: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    ...mapState(['login', 'searchProfile', 'pageType']),
    currentPage() {
      return this.login.currentPage
    },
    currentSearchProfile() {
      return this.registrationSearchProfile || this.searchProfile || null
    },
    currentPageType() {
      return (this.webtrekkPageType || this.pageType || 'joblist').toLowerCase()
    },
    formatClasses() {
      return this.modalWide
        ? 'fsd-session--wide'
        : 'columns small-12 medium-10 large-7'
    },
    showTroubleshootingLink() {
      return (
        (this.currentPage === 'emailLogin' && !!this.login.emailLoginEmail) ||
        this.currentPage === 'passwordLogin'
      )
    },
    showBackToLoginLink() {
      return ['troubleshooting', 'passwordRequest', 'emailRequest'].includes(
        this.currentPage
      )
    }
  },
  watch: {
    currentPage() {
      this.loginFailureReset()
      this.resetLoginEmails()
    }
  },
  methods: {
    ...mapActions([
      'loginFailureReset',
      'resetLoginEmails',
      'loginCurrentPageSet'
    ]),
    onTabChanged(_tab) {
      this.resetLoginEmails()
    }
  }
}
</script>

<style lang="scss" scoped></style>
